export const LOGIN_CHALLENGE_MESSAGE =
  'This phone number is already registered. Please download the app to manage your account.';

export const ACCOUNT_EXIST_MESSAGE =
  'Sorry, this phone number is already registered, please download the app to log in.';

/**
 * User's progress in the challenge flow.
 */
export enum SignupChallengeStep {
  Name = 'Name',
  Dob = 'Dob',
  Confirm = 'Confirm',
  Finished = 'Finished',
}
